import * as React from "react";
import { forwardRef, memo } from "react";
const SvgGr = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 27 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#0D5EAF", d: "M0 0h27v18H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "none", strokeWidth: 2, stroke: "#FFF", d: "M5 0v11M0 5h10m0-2h17M10 7h17M0 11h27M0 15h27" }));
const ForwardRef = forwardRef(SvgGr);
const Memo = memo(ForwardRef);
export default Memo;
